import { breakpoints, IconSolidInfo, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const TagDiscountFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;

  @media (min-width: ${breakpoints.md}) {
    margin-top: auto;
  }
`;

export const DiscountWrapper = styled.div`
  text-align: right;
  line-height: 1.25rem;
`;

export const OriginalPriceWrapper = styled.span`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  color: ${theme.color.text.tertiary};
  ${theme.typography.labelRegular400}
`;

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const LineThrough = styled.span<{ active: boolean }>`
  text-decoration: ${({ active }) => (active ? 'line-through' : 'none')};
  white-space: nowrap;
`;

export const Discount = styled.span`
  color: ${theme.color.text.highlight};
`;

export const PriceWrapper = styled.span`
  font-size: 0.8rem;
`;

export const ActionPriceWrapper = styled.span`
  ${theme.typography.labelRegular}
`;

export const CurrencyWrapper = styled(PriceWrapper)`
  &::before {
    content: ' ';
  }
`;

export const StyledInfoIcon = styled(IconSolidInfo)`
  display: block;
  margin-bottom: 4px;
`;
